import { isRunningInIframe } from "../../../utils/httpUtilities";

const getApiUrl = (): string =>
  // Use credit hound if running in an iframe.
  // If we have more apps, we should use the parent to identify the URL. Stay simple for now.
  isRunningInIframe()
    ? process.env.REACT_APP_CREDIT_HOUND_API_PROXY_URL ?? ""
    : process.env.REACT_APP_PAYTHEM_API_URL ?? "";
export default getApiUrl;
